<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody rel">
                            <img src="../../assets/croix.png" width="20" height="20" alt="" class="cross fright abs pointer" @click="closeModal();" />
                            <div class="modalContent">
                                <loader :loading="loading"></loader>
                                <h1 class="uppercase title center txtCenter">{{ $t("standDesign.create") }}</h1>
                                <table>
                                    <tr>
                                        <td>
                                            <label class="uppercase labelStand">{{ $t("standDesign.name") }}</label>
                                        </td>
                                        <td><input type="text" class="input inputSD" v-model="standDesign.name" /></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="uppercase labelStand">{{ $t("standDesign.description") }}</label>
                                        </td>
                                        <td><textarea type="text" class="input inputSDDdes" v-model="standDesign.description"></textarea></td>
                                    </tr>
                                </table>

                                <div class="txtCenter">
                                    <ClientColorButton :disabled="!canSave" @click="saveStandDesign();">
                                        {{ $t("standDesign.save") }}
                                    </ClientColorButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import httpService from "../service";
import loader from "@/components/loader/loader";
import ClientColorButton from "@/components/ui/ClientColorButton";
import standDesign from "@/services/stand-design";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import { isValidNameLength } from "@/utils/string";
import { mapGetters } from "vuex";

export default {
    mixins: [TryLoadMixin],
    components: { loader, ClientColorButton },
    data() {
        return {
            standDesign: {
                name: undefined,
                description: undefined,
                brand: {
                    id: undefined
                }
            }
        };
    },
    methods: {
        closeModal() {
            this.$emit("createStandDesign");
        },
        async saveStandDesign() {
            this.standDesign.brand.id = this.currentUser.brandId;
            try {
                this.loading = true;
                const res = await httpService.post("/admin/standDesigns", JSON.stringify(this.standDesign));
                if (res.code) throw res.message;
                location.reload();
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        ...mapGetters("currentUser", ["currentUser"]),
        canSave() {
            return this.nameIsCorrect && this.standDesign;
        },
        nameIsCorrect() {
            return isValidNameLength(this.standDesign.name);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.title {
    font-family: "Oswald", Sans-Serif;
}
/* height firefox modal */
._modalWrapper_ {
    height: auto;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 400;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: -10px;
        right: -10px;
        z-index: 2;
    }
}

.labelStand {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.inputSD {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
    @extend %primary-text;
    @extend %second-border-color;
}
.inputSDDdes {
    font-size: 16px;
    width: 100%;
    @extend %primary-text;
    @extend %second-border-color;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            @extend %second-bloc;
            @extend %primary-text;
            width: 900px;
            height: auto;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// CreateStandDesign.vue?4d336064